import ReactQuill from 'react-quill';

import { Block } from '@attom';

import 'react-quill/dist/quill.snow.css';

import CS from './TextEditor.module.scss';

export const TextEditor = ({
	// box Control
	boxClass = '',
	boxSize = '',
	boxSpace = 'p-2 ',
	//
	value = '',
	onChange = (value) => {},
	limitChar = null,
	hasBold = true,
	hasItalic = true,
	hasUnderline = true,
	hasStrike = true,
	hasLink = true,
	hasColor = true,
	hasBackground = true,
	hasOrderedList = true,
	hasBulletList = true,
	hasSub = true,
	hasSuper = true,
	hasHeader = true,
	hasImage = false,
	hasAlign = false,
	hasBlockQuote = false,
	hasFontSize = false,
	hasDirection = false,
	//
	theme = 'snow',
	direction = 'rtl',
	height = '300px',
	textAlign = 'right',
	style = {},
}) => {
	const space1Toolbar = [];
	if (hasBold) space1Toolbar.push('bold');
	if (hasItalic) space1Toolbar.push('italic');
	if (hasUnderline) space1Toolbar.push('underline');
	if (hasStrike) space1Toolbar.push('strike');
	if (hasLink) space1Toolbar.push('link');

	const space2Toolbar = [];
	if (hasColor) space2Toolbar.push({ color: [] });
	if (hasBackground) space2Toolbar.push({ background: [] });

	const space3Toolbar = [];
	if (hasAlign) space3Toolbar.push({ align: [] });
	if (hasOrderedList) space3Toolbar.push({ list: 'ordered' });
	if (hasBulletList) space3Toolbar.push({ list: 'bullet' });

	const space4Toolbar = [];
	if (hasSub) space4Toolbar.push({ script: 'sub' });
	if (hasSuper) space4Toolbar.push({ script: 'super' });

	const space5Toolbar = [];
	if (hasHeader) space5Toolbar.push({ header: [1, 2, 3, 4, 5, 6, false] });
	if (hasFontSize) space5Toolbar.push({ size: ['small', false, 'large'] });

	const space6Toolbar = [];
	if (hasImage) space6Toolbar.push('image');
	if (hasBlockQuote) space6Toolbar.push('blockquote');
	if (hasDirection) space6Toolbar.push({ direction: 'rtl' });

	const modules = {
		toolbar: [space1Toolbar, space2Toolbar, space3Toolbar, space4Toolbar, space5Toolbar, space6Toolbar],
	};

	const limitProgressBar =
		typeof limitChar === 'number' && value?.length
			? (value.length / limitChar) * 100 > 100
				? 100
				: (value.length / limitChar) * 100
			: null;

	function getColor(value) {
		let hue = ((1 - value) * 120).toString(10);
		return ['hsl(', hue, ',100%,65%)'].join('');
	}

	return (
		<Block boxClass={`${boxClass} ${CS.container}`} boxSize={boxSize} boxSpace={boxSpace}>
			<ReactQuill
				theme={theme}
				value={value}
				onChange={onChange}
				modules={modules}
				style={{ ...style, direction, height, textAlign }}
			/>
			{limitProgressBar !== null && (
				<div className={CS.barContainer}>
					<div
						className={CS.progress}
						style={{
							width: limitProgressBar + '%',
							backgroundColor: `${getColor(limitProgressBar / 100)}`,
						}}
					></div>
				</div>
			)}
		</Block>
	);
};

export default TextEditor;
